export default "__VITE_ASSET__85nc6YUA__"